/* tslint:disable */
/* eslint-disable */
/**
 * Famifarm-API
 * Famifarm API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LocalizedValue,
    LocalizedValueFromJSON,
    LocalizedValueFromJSONTyped,
    LocalizedValueToJSON,
} from './';

/**
 * 
 * @export
 * @interface PackageSize
 */
export interface PackageSize {
    /**
     * 
     * @type {string}
     * @memberof PackageSize
     */
    id?: string;
    /**
     * 
     * @type {Array<LocalizedValue>}
     * @memberof PackageSize
     */
    name?: Array<LocalizedValue>;
    /**
     * 
     * @type {number}
     * @memberof PackageSize
     */
    size?: number;
}

export function PackageSizeFromJSON(json: any): PackageSize {
    return PackageSizeFromJSONTyped(json, false);
}

export function PackageSizeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackageSize {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : ((json['name'] as Array<any>).map(LocalizedValueFromJSON)),
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function PackageSizeToJSON(value?: PackageSize | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name === undefined ? undefined : ((value.name as Array<any>).map(LocalizedValueToJSON)),
        'size': value.size,
    };
}


